export class TransferenciaModel {
    accountId: string = '';
    paymentOptions : string[] = ['PIX'];
    person : TransferenciaPersonModel = new TransferenciaPersonModel();
    value: number = 0;
    endToEndId : string = '';
}

export class TransferenciaPersonModel
{
  cpf: string = '';
  email: string = '';
  pixKeyTypes: string = '';
  pixKey: string = '';
  name: string = '';
  userId: string = 'WEB'
}
